export function roundTo2Dec(nbr) { return Math.round((nbr + Number.EPSILON) * 100) / 100 }